import React, { useEffect, useState } from "react";
import axios from "axios";
import { Building2 } from "lucide-react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { API } from "@/lib/api";
import { ADMIN_TOKEN_KEY } from "@/lib/constants";

export function WorkspaceSwitcher({ activeOrgId }) {
  const [workspaces, setWorkspaces] = useState([]);
  const [switching, setSwitching] = useState(false);

  useEffect(() => {
    axios.get(`${API}/workspaces`).then((response) => setWorkspaces(response.data?.workspaces || [])).catch(() => setWorkspaces([]));
  }, []);

  if (workspaces.length < 2) return null;

  const activate = async (orgId) => {
    if (!orgId || orgId === activeOrgId || switching) return;
    setSwitching(true);
    try {
      const response = await axios.post(`${API}/workspaces/${orgId}/activate`);
      localStorage.setItem(ADMIN_TOKEN_KEY, response.data.token);
      toast.success(`Workspace „${response.data.workspace?.company_name || "Organisation"}“ geöffnet`);
      window.setTimeout(() => window.location.reload(), 250);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Workspace konnte nicht gewechselt werden");
      setSwitching(false);
    }
  };

  return <Select value={activeOrgId || ""} onValueChange={activate} disabled={switching}>
    <SelectTrigger className="h-9 w-[190px] border-[var(--brand-border)] text-xs" data-testid="workspace-switcher">
      <Building2 className="w-3.5 h-3.5 mr-1 text-[var(--brand-primary)]" /><SelectValue placeholder="Workspace wählen" />
    </SelectTrigger>
    <SelectContent>
      {workspaces.map((item) => <SelectItem key={item.org_id} value={item.org_id}>{item.company_name}{item.kind === "betreuung" ? " · Betreuung" : ""}</SelectItem>)}
    </SelectContent>
  </Select>;
}
